import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Menu from './components/Menu/Menu';
import { getAsset } from '../../../../../util/assets';
import CollapsableMenu from './components/CollapsableMenu';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  signupDisabled: PropTypes.bool,
  isProView: PropTypes.bool,
};

const Wrapper = ({
  children,
  className,
  contentClassName,
  title,
  signupDisabled,
  isProView,
}) => {
  const classes = classNames({
    'marcom-layout-wrapper': true,
    [className]: !!className,
  });

  const contentClasses = classNames({
    'marcom-layout-content': true,
    [contentClassName]: !!contentClassName,
  });

  return (
    <div className={classes}>
      <Menu signupDisabled={signupDisabled} isProView={isProView} />
      <CollapsableMenu signupDisabled={signupDisabled} isProView={isProView} />
      <div className="marcom-layout-content-wrapper">
        {title && <div className="marcom-layout-title">{title}</div>}
        <div className={contentClasses}>{children}</div>
        <div className="marcom-layout-footer">
          <p className="mb-1 text-sm">
            Need help?{' '}
            <a href="mailto:support@waldophotos.com">Contact support</a>
          </p>
          <hr className="my-2" />
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex align-items-center mb-2">
              Over 17,000+&nbsp;
              <img className="stars" src={getAsset('/five-stars.png')} alt="" />
              &nbsp;reviews
            </div>
            <img
              src={getAsset('/press-logos-desktop-grey.png')}
              alt="press logos"
              className="logos d-none d-md-block"
            />
            <img
              src={getAsset('/press-logos-mobile-grey.png')}
              alt="press logos"
              className="logos d-block d-md-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Wrapper.propTypes = propTypes;

export default Wrapper;
